module.exports = __webpack_public_path__ + "img/edit.3cc697a7.svg";